export const links = [
    {
        id: 1, 
        text: "Finder", 
        url: "/finder", 
    },
]; 